import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsBiometryValidationScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.BiometryValidation />
    </View>
  );
};

export default PreProposalsBiometryValidationScreen;
